import { Autoplay, Navigation } from "swiper/modules";

export const SliderData = [
  { image: "1", icon: true },
  { image: "2", icon: false },
  { image: "3", icon: true },
  { image: "4", icon: true },
  { image: "2", icon: false },
];

export const CountersData = [
  { icon: "user", endValue: 80, title: "Happy Clients" },
  { icon: "square", endValue: 120, title: "Project Completed" },
  { icon: "heart", endValue: 90, title: "Photo Capture" },
  { icon: "comments", endValue: 140, title: "Telephonic Talk" },
  { icon: "square", endValue: 120, title: "Project Completed" },
];

export const SliderSettingsData = {
  slidesPerView: 4,
  spaceBetween: 30,
  loop: true,
  modules: [Navigation, Autoplay],
  autoplay: { delay: 2500, disableOnInteraction: false },
  navigation: true,
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    1070: {
      slidesPerView: 3,
      spaceBetween: 25,
    },
    1600: {
      slidesPerView: 4,
    },
  },
};

export const CountersSettingsData = {
  slidesPerView: 4,
  spaceBetween: 30,
  loop: true,
  modules: [Autoplay],
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    480: {
      slidesPerView: 2,
    },
    575: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 25,
    },
  },
};
